/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-23 20:23:54 */

const Keys = {
  bannerText: 'bannerText',
  close: 'close',
  location: 'location',
  from: 'from',
  showHotel: 'showHotel',
  MAP: 'MAP'
}; export default Keys;